/**
 * Zod schemas for Ambito (scope) API responses.
 */
import { z } from 'zod';

export const AmbitoResponseSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  codigo: z.string(),
  prefijo: z.string().nullable(),
});

export type AmbitoResponse = z.infer<typeof AmbitoResponseSchema>;
